import { render, staticRenderFns } from "./CuratedRtqInstumentsTable.vue?vue&type=template&id=6c79f3ea&scoped=true"
import script from "./CuratedRtqInstumentsTable.vue?vue&type=script&lang=ts"
export * from "./CuratedRtqInstumentsTable.vue?vue&type=script&lang=ts"
import style0 from "./CuratedRtqInstumentsTable.vue?vue&type=style&index=0&id=6c79f3ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c79f3ea",
  null
  
)

export default component.exports